import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [SidenavComponent],
  imports: [CommonModule, RouterModule, MaterialModule],
  exports: [SidenavComponent],
})
export class SidenavModule {}
